export const ERROR_MESSAGE_INVALID_EMAIL = 'Vennligst oppgi en gyldig e-postadresse.';

export const SUGGESTION_PREFIX = 'Mente du:';

export const DEFAULT_EMAIL_LABEL = 'E-postadresse';

/**
 * Builds suggested email by merging the local part (before @) with the suggested host name.
 */
export function getSuggestedEmail(value: string, suggestedHostName: string | null): string | null {
  if (!suggestedHostName || !value) {
    return null;
  }
  const emailParts = value.split('@');
  const localPart = emailParts[0];
  if (!localPart) {
    return null;
  }
  return `${localPart}@${suggestedHostName}`;
}
